import _asyncToGenerator from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
export default function callInSWR() {
  return _callInSWR.apply(this, arguments);
}
function _callInSWR() {
  _callInSWR = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var args,
      api,
      apiFn,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            args = Array.prototype.slice.call(_args);
            api = args.shift();
            apiFn = args.shift();
            return _context.abrupt("return", apiFn.apply(api, args));
          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _callInSWR.apply(this, arguments);
}